/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EvidenceItem } from './EvidenceItem';
import {
    EvidenceItemFromJSON,
    EvidenceItemFromJSONTyped,
    EvidenceItemToJSON,
    EvidenceItemToJSONTyped,
} from './EvidenceItem';

/**
 * Match result info in evidence response
 * @export
 * @interface EvidenceMatchResult
 */
export interface EvidenceMatchResult {
    /**
     * 
     * @type {string}
     * @memberof EvidenceMatchResult
     */
    submittedBy?: string;
    /**
     * 
     * @type {number}
     * @memberof EvidenceMatchResult
     */
    submittedAt?: number;
    /**
     * 
     * @type {Array<EvidenceItem>}
     * @memberof EvidenceMatchResult
     */
    evidence?: Array<EvidenceItem>;
}

/**
 * Check if a given object implements the EvidenceMatchResult interface.
 */
export function instanceOfEvidenceMatchResult(value: object): value is EvidenceMatchResult {
    return true;
}

export function EvidenceMatchResultFromJSON(json: any): EvidenceMatchResult {
    return EvidenceMatchResultFromJSONTyped(json, false);
}

export function EvidenceMatchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvidenceMatchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'submittedBy': json['submittedBy'] == null ? undefined : json['submittedBy'],
        'submittedAt': json['submittedAt'] == null ? undefined : json['submittedAt'],
        'evidence': json['evidence'] == null ? undefined : ((json['evidence'] as Array<any>).map(EvidenceItemFromJSON)),
    };
}

export function EvidenceMatchResultToJSON(json: any): EvidenceMatchResult {
    return EvidenceMatchResultToJSONTyped(json, false);
}

export function EvidenceMatchResultToJSONTyped(value?: EvidenceMatchResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'submittedBy': value['submittedBy'],
        'submittedAt': value['submittedAt'],
        'evidence': value['evidence'] == null ? undefined : ((value['evidence'] as Array<any>).map(EvidenceItemToJSON)),
    };
}

